export default __webpack_public_path__ + "static/media/Helvetica-Neue-LT-57-Condensed.1c8b9de9.ttf";